var _path, _g, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11913_9247",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 17,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66797 1.66406H17.8986V17.8949H1.66797V1.66406Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11913_9247)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7838 2.91406C5.99797 2.91406 2.91797 5.99323 2.91797 9.77906C2.91797 13.5649 5.99797 16.6449 9.7838 16.6449C13.5688 16.6449 16.6488 13.5649 16.6488 9.77906C16.6488 5.99323 13.5688 2.91406 9.7838 2.91406ZM9.7838 17.8949C5.3088 17.8949 1.66797 14.2541 1.66797 9.77906C1.66797 5.30406 5.3088 1.66406 9.7838 1.66406C14.2588 1.66406 17.8988 5.30406 17.8988 9.77906C17.8988 14.2541 14.2588 17.8949 9.7838 17.8949Z",
    fill: "#B8B8B8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11913_9247",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 5,
    height: 5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3672 14.75H18.5539V18.929H14.3672V14.75Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11913_9247)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9291 18.929C17.7699 18.929 17.6099 18.8681 17.4874 18.7465L14.5507 15.8181C14.3066 15.574 14.3057 15.1781 14.5499 14.934C14.7932 14.6881 15.1891 14.6898 15.4341 14.9323L18.3707 17.8615C18.6149 18.1056 18.6157 18.5006 18.3716 18.7448C18.2499 18.8681 18.0891 18.929 17.9291 18.929Z",
    fill: "#B8B8B8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.5ede7839457160c199835a022c79a380.svg";
export { ForwardRef as ReactComponent };